import React from 'react';
import styles from './DirectorInformations.module.sass';
import Card from '../../../../components/Card';
import TextInput from '../../../../components/TextInput';
import PhoneInput from '../../../../components/PhoneInput';
import Dropdown from '../../../../components/Dropdown';

const DirectorInformations = ({ company, onCompanyChange, onDropdownChange }) => {
    const FUNCTION_OPTIONS = [
        { value: 'RH', title: 'Ressources Humaines' },
        { value: 'Tuteur', title: 'Tuteur/Maître de stage' },
        { value: 'Dirigeant', title: 'Dirigeant' },
        { value: 'Manager', title: 'Manager' },
        { value: 'Responsable formation', title: 'Responsable formation' },
        { value: 'Autre', title: 'Autre' }
    ];
    return (
        <Card className={styles.card} title="Informations du représentant" classTitle="title-green">
            <div className={styles.group}>
                <TextInput
                    className={styles.field}
                    label="Nom"
                    name="representative_lastname"
                    type="text"
                    value={company?.representative_lastname || ''}
                    onChange={onCompanyChange}
                    required
                />
                <TextInput
                    className={styles.field}
                    label="Prénom"
                    name="representative_firstname"
                    type="text"
                    value={company?.representative_firstname || ''}
                    onChange={onCompanyChange}
                    required
                />
                <div className={styles.field}>
                    <label>Fonction *</label>
                    <Dropdown
                        options={FUNCTION_OPTIONS}
                        value={FUNCTION_OPTIONS.find(opt => opt.value === company?.representative_function) || ''}
                        setValue={(option) => onDropdownChange('representative_function', option)}
                        placeholder="RH, tuteur, dirigeant..."
                    />
                </div>
                <PhoneInput
                    className={styles.field}
                    label="Téléphone professionnel"
                    name="representative_phone"
                    id="representative_phone"
                    value={company?.representative_phone || ''}
                    onChange={onCompanyChange}
                    required
                />
            </div>
            <TextInput
                className={styles.field}
                label="Email professionnel"
                name="representative_email"
                type="email"
                value={company?.representative_email || ''}
                onChange={onCompanyChange}
                required
            />

        </Card>
    );
};

export default DirectorInformations;